import FirstLogin from './components/FirstLogin.vue';
import Login from './components/Login.vue';
import SamlError from './components/SamlError.vue';

export default {

  install(vue) {
    vue.$router.addRoutes([
      { path: '/first', component: FirstLogin },
      { path: '/login', component: Login },
      { path: '/saml/error', component: SamlError },
    ]);
  },

};
